<template>
  <div>
    <div v-if="locationReviews && locationReviews.length">
      <review-item v-for="(review, index) in locationReviews" :item="review" :key="index"></review-item>
    </div>
    <div v-else>
      <empty-data iconColor="#444" :message="$t('empty.reviews')" icon="k-icon-star" textColor="#000"></empty-data>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ReviewItem from "./ReviewItem";
import EmptyData from "./EmptyData";

export default {
  name: "reviews-modal",
  components: {
    ReviewItem,
    EmptyData,
  },
  computed: {
    ...mapState('locationStore', ['locationReviews']),
  },
  methods: {
    ...mapActions('locationStore', ["fetchLocationReviews"]),
  },
  created() {
    if (!this.isLocationEmpty())
      this.fetchLocationReviews(this.selectedLocation.id);
  },
};
</script>